import Form from '../_form';
import Popup from '../../components/popup';

import debounce from '../../utils/debounce';

export default class ProjectInvitationForm extends Form {

    /* eslint-disable no-useless-constructor */
    constructor (query) {
        super(query);

        this.attached = [];

        const attachedEl = this.form.querySelector('#attached-users');

        this.attached = new Proxy(this.attached, {
            set: (target, property, value) => {
                const result = Reflect.set(target, property, value);

                if (property === 'length') {
                    if (target.length > 0) {
                        this.submit.removeAttribute('disabled');

                        attachedEl.classList.remove('hidden');
                    } else {
                        this.submit.setAttribute('disabled', '');

                        attachedEl.classList.add('hidden');
                    }
                }

                return result;
            }
        });

        const reset = this.form.querySelector('.site-button[type="reset"]');

        this.popup = new Popup({
            popup: '.site-popup[data-popup="invitation"]',
            toggle: '#invitation-trigger',
            close: '.site-popup-close[data-popup="invitation"]',
            window: '.site-popup-window[data-popup="invitation"]'
        });

        reset.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();

            this.popup.close.click();
        });

        this.formParts = {};

        this.handleSearch();
        this.handleList();
    }

    handleList () {
        const list = this.form.querySelector('#invitation-search-results');

        const observer = new MutationObserver(() => {
            if (list.children.length > 0) {
                list.classList.remove('hidden');
            } else {
                list.classList.add('hidden');
            }
        });
    
        observer.observe(list, { childList: true });
    
        if (list.children.length > 0) {
            list.classList.remove('hidden');
        } else {
            list.classList.add('hidden');
        }
    }

    handleSearch () {
        const gthis = this;

        const search = this.form.querySelector('input[name="search"]');
        const list = this.form.querySelector('#invitation-search-results');

        const field = this.form.querySelector('input[name="search"]').parentNode;
        const attached = this.form.querySelector('#attached-users');

        this.formParts.list = list;
        this.formParts.field = field;

        const clear = () => {
            list.innerHTML = '';
            list.classList.add('hidden');
        }

        const handler = debounce(function () {
            if (!list.classList.contains('hidden')) return;

            const { value } = search;

            const reName = /^[a-zA-Z\s]+$/;
            const reEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

            const valid = reName.test(value.trim().toLowerCase()) || reEmail.test(value.trim().toLowerCase());

            if (value.length >= 3 && valid) {
                (async () => {
                    try {
                        await fetch('/wp-json/user/v1/search', {
                            method: 'POST',
                            headers: {
                                'Content-Type': 'application/json'
                            },
                            body: JSON.stringify({ value })
                        })
                        .then((response) => response.json())
                        .then((data) => {
                            if (data.data && data.data.length && !data.error) {
                                data.data.forEach((user) => {
                                    const li = document.createElement('li');

                                    li.setAttribute('tabindex', '0');
                                    li.setAttribute('data-user', `user-${user.id}`);

                                    li.innerHTML = `
                                        <div class="site-project--invitation-form-list-profile">
                                            ${user.profile_picture 
                                                ? `<img src="${user.profile_picture}" alt="${user.display_name}" />` 
                                                : `<div class="site-project--invitation-form-list-profile-placeholder">${user.display_name.charAt(0).toUpperCase()}</div>`
                                            }
                                        </div>
                                        <div class="site-project--invitation-form-list-data">
                                            <h4 class="h5 site-title site-project--invitation-form-list-name">
                                                ${user.display_name}
                                            </h4>
                                            <div class="site-project--invitation-form-list-email">
                                                ${user.user_email}
                                            </div>
                                        </div>
                                    `;

                                    li.addEventListener('click', (event) => {
                                        event.stopPropagation();

                                        const instance = {
                                            id: user.id,
                                            output: user.display_name,
                                            internal: true
                                        }

                                        const isDuplicate = gthis.attached.find((item) => item.id === user.id);

                                        if (!isDuplicate) {
                                            gthis.attached.push(instance);

                                            const ili = document.createElement('li');

                                            ili.innerHTML = `
                                                <span>${user.display_name}</span>
                                                <button class="site-button icon">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.1831 3.93306L3.93306 15.1831C3.81585 15.3003 3.75 15.4592 3.75 15.625C3.75 15.7908 3.81585 15.9497 3.93306 16.0669C4.05027 16.1842 4.20924 16.25 4.375 16.25C4.54076 16.25 4.69973 16.1842 4.81694 16.0669L16.0669 4.81694C16.1842 4.69973 16.25 4.54076 16.25 4.375C16.25 4.20924 16.1842 4.05027 16.0669 3.93306C15.9497 3.81585 15.7908 3.75 15.625 3.75C15.4592 3.75 15.3003 3.81585 15.1831 3.93306Z" fill="#D5D5D5"></path>
                                                        <path d="M4.81694 3.93306C4.69973 3.81585 4.54076 3.75 4.375 3.75C4.20924 3.75 4.05027 3.81585 3.93306 3.93306C3.81585 4.05027 3.75 4.20924 3.75 4.375C3.75 4.54076 3.81585 4.69973 3.93306 4.81694L15.1831 16.0669C15.3003 16.1842 15.4592 16.25 15.625 16.25C15.7908 16.25 15.9497 16.1842 16.0669 16.0669C16.1842 15.9497 16.25 15.7908 16.25 15.625C16.25 15.4592 16.1842 15.3003 16.0669 15.1831L4.81694 3.93306Z" fill="#D5D5D5"></path>
                                                    </svg>
                                                </button>
                                            `;

                                            attached.append(ili);

                                            ili.querySelector('button').addEventListener('click', (e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                ili.remove();

                                                gthis.attached.splice(gthis.attached.indexOf(instance), 1);
                                            });
                                        }

                                        search.value = '';
                                        list.innerHTML = '';
                                        list.classList.add('hidden');
                                    });

                                    list.append(li);
                                });

                                list.classList.remove('hidden');
                            } else {
                                if (reEmail.test(value.trim().toLowerCase())) {
                                    const li = document.createElement('li');

                                    li.setAttribute('tabindex', '0');

                                    li.innerHTML = `
                                        <div class="site-project--invitation-form-list-profile">
                                            <div class="site-project--invitation-form-list-profile-placeholder">@</div>
                                        </div>
                                        <div class="site-project--invitation-form-list-data">
                                            <h4 class="h5 site-title site-project--invitation-form-list-name">
                                                ${value.trim().toLowerCase()}
                                            </h4>
                                            <div class="site-project--invitation-form-list-email">
                                                Invitation by email
                                            </div>
                                        </div>
                                    `;

                                    list.append(li);

                                    li.addEventListener('click', (event) => {
                                        event.stopPropagation();

                                        const instance = {
                                            id: null,
                                            output: value.trim().toLowerCase(),
                                            internal: false
                                        }

                                        const isDuplicate = gthis.attached.find((item) => item.internal === false && item.output === instance.output);

                                        if (!isDuplicate) {
                                            gthis.attached.push(instance);

                                            const ili = document.createElement('li');

                                            ili.classList.add('external');

                                            ili.innerHTML = `
                                                <span>${instance.output}</span>
                                                <button class="site-button icon">
                                                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15.1831 3.93306L3.93306 15.1831C3.81585 15.3003 3.75 15.4592 3.75 15.625C3.75 15.7908 3.81585 15.9497 3.93306 16.0669C4.05027 16.1842 4.20924 16.25 4.375 16.25C4.54076 16.25 4.69973 16.1842 4.81694 16.0669L16.0669 4.81694C16.1842 4.69973 16.25 4.54076 16.25 4.375C16.25 4.20924 16.1842 4.05027 16.0669 3.93306C15.9497 3.81585 15.7908 3.75 15.625 3.75C15.4592 3.75 15.3003 3.81585 15.1831 3.93306Z" fill="#5C5C5C"></path>
                                                        <path d="M4.81694 3.93306C4.69973 3.81585 4.54076 3.75 4.375 3.75C4.20924 3.75 4.05027 3.81585 3.93306 3.93306C3.81585 4.05027 3.75 4.20924 3.75 4.375C3.75 4.54076 3.81585 4.69973 3.93306 4.81694L15.1831 16.0669C15.3003 16.1842 15.4592 16.25 15.625 16.25C15.7908 16.25 15.9497 16.1842 16.0669 16.0669C16.1842 15.9497 16.25 15.7908 16.25 15.625C16.25 15.4592 16.1842 15.3003 16.0669 15.1831L4.81694 3.93306Z" fill="#5C5C5C"></path>
                                                    </svg>
                                                </button>
                                            `;

                                            attached.append(ili);

                                            ili.querySelector('button').addEventListener('click', (e) => {
                                                e.preventDefault();
                                                e.stopPropagation();

                                                ili.remove();

                                                gthis.attached.splice(gthis.attached.indexOf(instance), 1);
                                            });
                                        }

                                        search.value = '';
                                        list.innerHTML = '';
                                        list.classList.add('hidden');
                                    });

                                    list.classList.remove('hidden');
                                }
                            }
                        })
                        .catch(() => {
                            this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
                        });
                    } catch (error) {
                        this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
                    }
                })();
            } else {
                list.innerHTML = '';
                list.classList.add('hidden');
            }
        }, 300);

        search.addEventListener('input', clear);
        search.addEventListener('input', handler);
    }

    async finalizeForm () {
        if (this.submit) this.submit.classList.add('preload');

        const formData = new FormData(this.form);

        const postId = formData.get('post_id') || '';

        const attachedList = JSON.parse(JSON.stringify(this.attached));

        if (!attachedList.length) return;

        attachedList.forEach((item, index) => {
            setTimeout(async () => {
                const { internal, id, output } = item;

                try {
                    await fetch('/wp-json/projects/v1/invite', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({ internal, id, email: output, postId })
                    })
                    .then((response) => response.json())
                    .then((data) => {
                        if (data && !data.error) {
                            this.form.classList.remove('error');
                            this.form.classList.add('sent');
        
                            this.NotificationManager.sendNotification('success', `${output} invited!`, data.message);
        
                            if (this.submit) this.submit.classList.remove('preload');
                        } else {
                            this.NotificationManager.sendNotification('error', `${output} not invited!`, data.message);
        
                            if (this.submit) this.submit.classList.remove('preload');
        
                            this.form.classList.add('error');
                        }
                    })
                    .catch(() => {
                        this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
        
                        if (this.submit) this.submit.classList.remove('preload');
        
                        this.form.classList.add('error');
                    });
        
                    this.popup.close.click();
                } catch (error) {
                    this.NotificationManager.sendNotification('error', 'An error occurred...', 'Please, try again');
        
                    if (this.submit) this.submit.classList.remove('preload');
        
                    this.form.classList.add('error');
        
                    this.popup.close.click();
                }
            }, index * 1000);
        });

        this.form.reset();

        const list = this.form.querySelector('#invitation-search-results');
        const attached = this.form.querySelector('#attached-users');

        list.innerHTML = '';
        list.classList.add('hidden');

        attached.innerHTML = '';

        this.attached = [];
    }
}
